import axios from 'axios'

export default {
  fetchTimeOffsAdjustments (userId, year) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/time-offs-adjustments?user_id=${userId}&year=${year}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  addTimeOffsAdjustment (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/time-offs-adjustments/`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  }
}
